import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import i18next from 'i18next';
import isString from 'lodash/isString';
import isNetworkError from '../util/isNetworkError';
/**
 * @param {*} error
 * @param {string} networkErrorMessage
 *
 * @returns {Promise<?string>}
 */

export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error, networkErrorMessage) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isNetworkError(error)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", null);

          case 2:
            if (!isString(networkErrorMessage)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", networkErrorMessage);

          case 4:
            _context.next = 6;
            return i18next.loadNamespaces('error-message-resolver');

          case 6:
            return _context.abrupt("return", i18next.t('error-message-resolver:network_error'));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();